import { ApiGroup } from "../types/ApiTypes"

const AppVersionAPI: ApiGroup = {
    getAll: {
        title: "앱 버전 전체 목록 조회",
        url: "/AppVersion",
        method: "GET",
        paramz: {},
    },
    getById: {
        title: "앱 버전 단건 조회",
        url: "/AppVersion/GetById/:seqId",
        method: "GET",
        paramz: {},
        pathParams: ["seqId"],
    },
    create: {
        title: "앱 버전 등록",
        url: "/AppVersion/Create",
        method: "POST",
        paramz: {
            platform: "",
            version: "",
            minVersion: "",
            updateType: "",
            title: "",
            message: "",
            storeUrl: "",
            isActive: true,
        },
    },
    update: {
        title: "앱 버전 수정",
        url: "/AppVersion/Update/:seqId",
        method: "PUT",
        paramz: {},
        pathParams: ["seqId"],
    },
    delete: {
        title: "앱 버전 삭제",
        url: "/AppVersion/Delete/:seqId",
        method: "DELETE",
        paramz: {},
        pathParams: ["seqId"],
    },
    storeVersions: {
        title: "스토어 배포 버전 조회",
        url: "/AppVersion/StoreVersions",
        method: "GET",
        paramz: {},
    },
}

export default AppVersionAPI
